const ufeApi = require('services/api/ufeApi');


// https://jira.sephora.com/wiki/display/ILLUMINATE/Update+Play+Quiz+Details


function updatePlayQuizDetails(quizData) {
    const url = '/api/users/profiles/playQuiz';
    return ufeApi.makeRequest(url, {
        method: 'POST',
        body: JSON.stringify(quizData)
    }).then(data => data.errorCode ? Promise.reject(data) : data);
}


module.exports = updatePlayQuizDetails;
